
//user관련 | My Page 화면 라우터
const pubUsertRouter = [
     
    /* 화면명 : 임시저장함  : MMP_AM_001  */
    {
        path: "/publish/mp/MMP_AM_001", 
        name : 'PUB_MMP_AM_001',
        component: () => import('@/views/publish/mp/MMP_AM_001.vue')
    },

     
    /* 화면명 : 알람조회  : MMP_AM_002  */
    {
        path: "/publish/mp/MMP_AM_002", 
        name : 'PUB_MMP_AM_002',
        component: () => import('@/views/publish/mp/MMP_AM_002.vue')
    },

     /* 화면명 :  아이디/비밀번호 찾기  : PCM_AM_001  */
     {
        path: "/publish/MP/PCM_AM_001", 
        name : 'PUB_PCM_AM_001',
        component: () => import('@/views/publish/mp/PCM_AM_001.vue')
    },

    /* 화면명 :  비밀번호 변경  : PCM_AM_002  */
    {
        path: "/publish/MP/PCM_AM_002", 
        name : 'PUB_PCM_AM_002',
        component: () => import('@/views/publish/mp/PCM_AM_002.vue')
    },





]
export{pubUsertRouter}